// extracted by mini-css-extract-plugin
module.exports = {"table":"metric-table_table__2Yb2W","percentageCell":"metric-table_percentageCell__11fI4","currencyCell":"metric-table_currencyCell__RdQC9"};